// @flow

import React from 'react';

import {
  assetFeatures,
  assetTypes,
  COUNTRIES,
} from '../const';
import type { ShoppingCenter } from '../types/shoppingCenterType';
import { glaWithoutSst, glaWithSst, ocr } from '../pages/mall/map/gemini/geminiConst';

export const getAssetType = (type: string) =>
  Object.keys(assetTypes).map(key => assetTypes[key]).filter(elt => elt.type === type)[0];

export const getCountryFromCode = (countryCode: string) =>
  Object.keys(COUNTRIES).map(key => COUNTRIES[key])
    .filter(elt => elt.countryCodeList.includes(countryCode))[0];

export const isUSDorGBP = (twCurrency: string) => (twCurrency === 'USD' || twCurrency === 'GBP');

export function isWestfieldAsset(sc: ShoppingCenter) {
  return sc.assetFeatures.filter(e => e.id === assetFeatures.westfield.id).length > 0;
}

export function isAssetInDevelopment(sc: ShoppingCenter) {
  return sc.assetFeatures.filter(e => e.id === assetFeatures.development.id).length > 0;
}

export function getRandomColor(): string {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const isKPIValuesReversed = (currentKpiFilter: string) =>
  currentKpiFilter === ocr || currentKpiFilter === glaWithSst || currentKpiFilter === glaWithoutSst;

export function detectIEEdge() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return null;
}

export function isOutdatedNavigator() {
  const detectIEE = detectIEEdge();
  return !!detectIEE && detectIEE <= 45;
}

export const download = (blobOrUrl: string, filename: string, cb?: Function) => {
  if (typeof blobOrUrl === 'string') {
    // fixme : Doesn't work most of the time in chrome and firefox a it support only same origin download link
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = blobOrUrl;
    a.download = filename;
    a.click();
  } else if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blobOrUrl, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = window.URL.createObjectURL(blobOrUrl);
    a.download = filename;
    a.click();
  }
  if (cb) {
    cb();
  }
};

export const deepCompare = (object1: Object, object2: Object) =>
  (JSON.stringify(object1) !== JSON.stringify(object2));

export const intRange = (min: number, max: number) =>
  Array.from({ length: max - min + 1 }, (_, i) => min + i);

export const isUndefined = (value: number | string): boolean => !value && value !== 0;
